import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import api from '@http/api';
import { useAuth } from '@hooks/AuthenticateContext';

import { Checkbox, Grid} from '@material-ui/core';
import { TuneOutlined} from '@material-ui/icons';
import Button from '@components/Shared/Buttons/Button';
import { FormatDate } from '@utils/formats';
import { Form, Select as SelectAntd,  Input, } from 'antd';
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
import ButtonWithIcon from '@components/Shared/Buttons/ButtonWithIcon';
import Modal from '@src/components/Shared/Modal/ModalPure';
import ApproveSolicitacao from '@src/Pages/Private/shared/SolicitacaoAtendimento/ListAtendidos/ProgramaTv/approveSolicitacao';
import Filtros from '@src/components/Shared/Filtros';
import TableCustomKeysNoPagination from '@src/components/Shared/Tables/TableCustomKeysNoPagination';

import Services, {
  ILista,
  IGetAllProgramaTv,
  ISolicitacaoResultTable
} from './services';
import { fontSize } from '@mui/system';


const columnsLabel = {
  perfilId: 'Nome',
  programaId: 'Programa',
  descricao: 'Descrição',
  dataCadastro: 'Data cadastro'
};


let  dataSelect: any;
let  programaSelect: any;
let conteudo: any;


interface IProps {
  functionReload?: Function;
}

const SolicitacaoIntencaoMissa: React.FC<IProps> = ({
  functionReload,
}) => {
  const [formRef] = Form.useForm();
  const { user } = useAuth()
  const { enqueueSnackbar } = useSnackbar();

  const [data, setData] = useState<ILista[]>([]);
  const [statusSolicitacao, setStatusSolicitacao] = useState(false);

  const [loading, setLoading] = useState(true);
  const [filtros, setFiltros] = useState(false);

  const [programas, setProgramas] = useState<IGetAllProgramaTv[]>([]);
  const [programaSelected, setProgramaSelected] = useState<number>(0);
  const [dataSelected, setDataSelected] = useState<string>('0001-01-01T00:00:00');
  const [horarioSelected, setHorarioSelect] = useState<any>('');
  const [dadosSelecionadas, setDadosSelecionadas] = useState<string[]>([]);

  const [openModalApproveSolicitacao, setOpenModalApproveSolicitacao] =
  useState(false);

  conteudo = data.length <= 0

  const gerarCSV = async () => {
    setLoading(true);
    const services = new Services();
    const { error, response } = await services.GerarCSV(statusSolicitacao, programaSelected, dataSelected, horarioSelected);

    if (!error && response) {
      window.open(response);
    }

    setLoading(false);
  };




  async function loadListaAllPrograma() {
    setLoading(true);
    await api
      .get( `api/SolicitacaoPrograma/GetAllSolicitacaoPrograma?StatusSolicitacao=${statusSolicitacao}`)

      .then(response => {
        const items = response.data;
        const itemData: ILista[] = items.map((item: ILista) => ({
          id: item.id,
          perfilId: item.perfil.pessoa.nome,
          programaId: item.programa.nome,
          descricao: item.descricao,
          dataCadastro: FormatDate(item.dataCadastro),

        }));

        setData(itemData);
        setLoading(false);
      })
      .catch(error => {
        //alert(error);
        enqueueSnackbar(`Não foi possivel carregar a lista`, {
          variant: 'error',
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        });
      });
  }

  async function loadListaAllIntencaoMissaFiltros() {
    const programaSelecteds = formRef.getFieldValue('programa');
    setLoading(true);
    await api
      .get(`api/SolicitacaoPrograma/GetAllSolicitacaoPrograma?StatusSolicitacao=${statusSolicitacao}&ProgramaId=${programaSelected}`)

      .then(response => {
        const items = response.data;
        const itemData: ILista[] = items.map((item: ILista) => ({
          id: item.id,
          perfilId: item.perfil.pessoa.nome,
          programaId: item.programa.nome,
          descricao: item.descricao,
          dataCadastro: FormatDate(item.dataCadastro),
        }));

        setData(itemData);
        setLoading(false);
      })
      .catch(error => {
       //alert(error);
       enqueueSnackbar(`Não foi possivel carregar a lista`, {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      });
  }


  const loadProgramasTv = async () => {
    const services = new Services();
    const { error, response } = await services.GetAllProgramaTv();

    if (!error && response) {
      setProgramas(response);

    }
  };

  async function pegarData(data_agendada: Date){

    dataSelect = new Date (data_agendada).toISOString();
    setDataSelected(dataSelect)

  };

  const selectedDatas = (value: ISolicitacaoResultTable) => {
    if (dadosSelecionadas.filter(x => x === value.id).length <= 0) {
      setDadosSelecionadas([...dadosSelecionadas, value.id]);
    } else {
      const newArray = dadosSelecionadas.filter(function (item) {
        return item !== value.id;
      });

      setDadosSelecionadas(newArray);
    }
  };

  const finishApproveSolicitacao = async () => {
    if (functionReload) {
      await functionReload();
    }
    setOpenModalApproveSolicitacao(false);
  };

  const handleOpen = () => {
    setFiltros(!filtros);
  };

  const clearData = () => {
    formRef.setFieldsValue({
      data_agendada: '',
      horario: '',
      programa: '',
    });
    setProgramaSelected(0)
    setDataSelected('0001-01-01T00:00:00')
    setHorarioSelect('')
  };


  useEffect(() => {
    loadListaAllPrograma();
    loadProgramasTv();
    //loadAllIntencoes();

    window.document.title = 'CRM - Lista Programa TV';
  }, []);


  return (
    <Grid container>
      <Grid
        container
        item
        sm={12}
        //justify="space-around"
        xs={12}
        lg={12}
        style={{ marginTop: 20 }}
      >
        <Grid item lg={12} sm={12} xs={12}>

          {/* Botões  */}
          <Grid container item lg={10} sm={10} xs={10} style={{ paddingTop: 10 }}>
            <Grid
              item
              md={8}
              lg={8}
              xs={6}
              style={{
                paddingRight: 5,
                paddingLeft: 5,
                alignSelf: 'flex-end',
                paddingTop: 10,
              }}
            >
              <Button
                color="secondary"
                fullWidth
                style={{
                  height: 46,
                  width: 200
                }}
                onClick={handleOpen}
              >
                <TuneOutlined style={{ marginRight: 10 }} /> Filtros
              </Button>
            </Grid>

            {/*<Grid
              item
              md={3}
              lg={3}
              xs={4}
              style={{
                paddingRight: 5,
                paddingLeft: 50,
                alignSelf: 'end',
                paddingTop: 10,
              }}
            >
              <Button
                color="primary"
                style={{
                  height: 46,
                  width: 200
                }}
                onClick={gerarCSV}
                disabled={conteudo === true}
              >
                Gerar csv
              </Button>
            </Grid>*/}

            <Modal
              title="Aprovar solicitações"
              size="medio"
              openModal={openModalApproveSolicitacao}
              controlModal={(value: boolean) =>
              setOpenModalApproveSolicitacao(value)
              }
            >
              <ApproveSolicitacao
                //perfil_id={idPerfil}
                finishCreate={finishApproveSolicitacao}
                solicitacoes_programa_id={dadosSelecionadas}
              />
            </Modal>

            <Grid item md={2} xs={4} style={{ margin: 5 }}>
              <ButtonWithIcon
                color="secondary"
                fullWidth
                disabled={dadosSelecionadas.length <= 0}
                onClick={() => setOpenModalApproveSolicitacao(true)}
                titleButton="Aprovar solicitações"
                //Icon={() => <Icon path={mdiArrowTopRight} size={1} color="White" />}
              ></ButtonWithIcon>
            </Grid>
          </Grid>

          {/* Filtros  */}
          <Filtros abrir={filtros} openMenu={handleOpen}>
            <Grid
              item
              md={12}
              lg={12}
              xs={12}
              style={{ paddingRight: 10, paddingLeft: 10, paddingTop: 10 }}
            >
             <Form className="filtros " layout={'vertical'} form={formRef}
               initialValues={{
                data_agendada: '',
                horario: '',
                programa: '',
                }}
              >

                <Grid
                  item
                  md={12}
                  lg={12}
                  xs={12}
                  style={{
                    paddingRight: 10,
                    paddingLeft: 10,
                    alignSelf: 'flex-end',
                    paddingTop: 10,
                  }}
                >
                   <Form.Item
                    name="programa"
                    label={<label style={{ color: '#fff' }}>Programa</label>}
                  >
                   <SelectAntd
                      style={{ width: '100%' }}
                      onChange={(e: any) => {setProgramaSelected(e);}}
                    >
                      {programas.map((option, index) => (
                        <SelectAntd.Option key={option.id} value={option.id}>
                          {option.nome}
                        </SelectAntd.Option>
                      ))}
                    </SelectAntd>
                  </Form.Item>
                </Grid>







                <Grid
                  item container
                  md={12}
                  lg={12}
                  xs={12}
                  style={{
                    paddingRight: 5,
                    paddingLeft: 5,
                    //alignSelf: 'flex-end',
                    //paddingTop: 10,
                  }}
                >
                  <Grid
                  item
                  md={5}
                  lg={5}
                  xs={12}
                  style={{
                    paddingRight: 5,
                    paddingLeft: 5,
                    //alignSelf: 'flex-end',
                    paddingTop: 10,
                  }}
                >
                  <Button
                    color="primary"
                    fullWidth
                    style={{
                      height: 46,
                    }}
                    onClick={loadListaAllIntencaoMissaFiltros}
                    //onClick={() => {loadListaAllIntencaoMissaFiltros(); loadAllIntencoesFiltros()}}

                  >
                   Buscar
                  </Button>
                </Grid>

                <Grid
                  item
                  md={5}
                  lg={5}
                  xs={12}
                  style={{
                    paddingRight: 5,
                    paddingLeft: 5,
                    //alignSelf: 'flex-end',
                    paddingTop: 10,
                  }}
                >
                  <Button
                    color="default"
                    fullWidth
                    style={{
                      height: 46,
                    }}
                    onClick={(e: any) => {loadListaAllPrograma(); clearData(); }}
                  >
                    Limpar filtros
                  </Button>
                </Grid>
                </Grid>


              </Form>
            </Grid>
          </Filtros>

          {/* Tabela  */}

          <Grid container item lg={12} sm={12} xs={12} style={{ padding: 0 }}>
            <Grid
              item
              lg={12}
              xs={12}
              style={{ paddingRight: 2, paddingLeft: 2, paddingTop: 5 }}
            >

              <TableCustomKeysNoPagination
               Selected={(e: ISolicitacaoResultTable) => (
                <Grid container justifyContent="center">
                  <Checkbox
                    onChange={() => selectedDatas(e)}
                    checked={
                      dadosSelecionadas.filter(x => x === e.id).length >
                      0
                    }
                  />
                </Grid>
              )}
                loading={loading}
                columns={[columnsLabel]}
                FieldsBold={['programaId']}
                data={data}
                keys={[
                  'perfilId',
                  'programaId',
                  'descricao',
                  'dataCadastro',
                ]}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SolicitacaoIntencaoMissa;
